export default function Header() {
  const scrollToSignup = () => {
    const signupElement = document.getElementById('signup');
    if (signupElement) {
      signupElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="bg-black border-b border-gray-800 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/1164fc9bbf614696e93ace8621ec6c97/5a18007f0b98deaa46809201650dd6ef.png" 
              alt="Prop Firm Police Logo" 
              className="h-64 w-auto"
            />
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#features" className="text-gray-300 hover:text-white font-medium cursor-pointer">Features</a>
            <a href="#how-it-works" className="text-gray-300 hover:text-white font-medium cursor-pointer">How It Works</a>
            <button 
              onClick={scrollToSignup}
              className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-2 rounded-full font-medium hover:shadow-lg transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Get Early Access
            </button>
          </nav>
          
          <button className="md:hidden p-2">
            <i className="ri-menu-line w-6 h-6 flex items-center justify-center text-gray-300"></i>
          </button>
        </div>
      </div>
    </header>
  );
}
